import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export const NFADisclaimer = () => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  useEffect(() => {
    const checkDisclaimerStatus = () => {
      const lastShownTimestamp = localStorage.getItem('nfaDisclaimerShown');
      const currentTime = new Date().getTime();
      
      // Show disclaimer if never shown before or if last shown more than 1 hour ago
      if (!lastShownTimestamp || currentTime - parseInt(lastShownTimestamp) > 5 * 60 * 1000) {
        setShowDisclaimer(true);
        // Update the timestamp when shown
        localStorage.setItem('nfaDisclaimerShown', currentTime.toString());
      }
    };

    checkDisclaimerStatus();
  }, []);

  const handleClose = () => {
    setShowDisclaimer(false);
  };

  return (
    <AnimatePresence>
      {showDisclaimer && (
        <motion.div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div 
            className="max-w-2xl bg-gray-900 border-2 border-pink-500 rounded-xl p-6 text-white overflow-y-auto max-h-[90vh]"
            initial={{ scale: 0.9, y: 20 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.9, y: 20 }}
          >
            <h2 className="text-3xl font-bold text-pink-500 mb-4">NFA & Disclaimers: We're Just Here to Purr</h2>
            
            <div className="space-y-4 text-gray-200">
              <p>
                Before you dive into the Purrtardio masterplan, let's set the record straight—this is NOT financial advice (NFA). 
                We're a community project, not a Wall Street firm. Think of us as a bunch of meme-loving weirdos, not your financial planner.
              </p>
              
              <h3 className="text-xl font-semibold text-pink-400">Here's the deal:</h3>
              
              <ul className="list-disc pl-6 space-y-2">
                <li><span className="font-bold text-pink-300">Memes Over Money:</span> Any chatter about $PURR soaring to $10 or beyond? Pure speculation, fam. It's like guessing if a cat can moonwalk—fun to imagine, not a promise.</li>
                <li><span className="font-bold text-pink-300">DYOR (Do Your Own Research):</span> We're not here to tell you to buy, sell, or HODL. Want investment tips? Ask your grandma; she's got better stories.</li>
                <li><span className="font-bold text-pink-300">Community, Not Cash:</span> Purrtardio is about building a cult of purrfection, not your bank account. If you're chasing gains, you're missing the vibe.</li>
                <li><span className="font-bold text-pink-300">Treasury Talk? Just Hypothetical:</span> Staking $HYPE, DCA-ing into $PURR, or wild vault ideas? That's us brainstorming, not guaranteeing anything. No profits promised—just purrs.</li>
              </ul>
              
              <p>
                Purrtardio is a meme-driven, community-fueled experiment. We're not liable for your financial moves, 
                your cat's sass, or blockchain chaos. Dive in with a grin and zero expectations. 
                This applies to the whole whitepaper—welcome to the purrty!
              </p>
            </div>
            
            <div className="mt-6 flex justify-center">
              <button 
                onClick={handleClose}
                className="bg-pink-500 hover:bg-pink-600 text-white font-bold py-2 px-6 rounded-full transition-colors"
              >
                I understand, let me purr!
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}; 